var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.currIndex,"page-sizes":[50,100,300,500,1000,5000],"page-size":_vm.pageSize,"layout":_vm.layout,"total":_vm.allPage},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }